/**
 * @import { RouteFeature } from '../types/route-feature'
 */

import { zIndex } from '@/features/itinerary-map/utils/layer';
import { highDetailMinZoom, useZoom } from '@/hooks/use-zoom';
import { useMap } from '@vis.gl/react-google-maps';
import { useMemo } from 'react';
import { usePolyline } from '../hooks/use-polyline';
import { useShowArrow } from '../hooks/use-show-arrow';
import { createArrowIconSequence } from '../utils/icon';

const lineColor = '#b10a32';

/**
 * @param {object} props
 * @param {RouteFeature} props.feature
 * @returns {React.JSX.Element}
 */
export function OceanPolyline({ feature }) {
  const map = useMap();
  const zoom = useZoom();
  const showArrow = useShowArrow(zoom, feature);

  const polylineOptions = useMemo(() => {
    if (!map) {
      return {};
    }

    return /** @type {google.maps.PolylineOptions} */ ({
      zIndex: zIndex.oceanPath,
      strokeColor: lineColor,
      icons: showArrow ? createArrowIconSequence(lineColor, highDetailMinZoom, zoom) : null,
      clickable: false,
    });
  }, [map, showArrow, zoom]);

  usePolyline(feature, polylineOptions);

  return <></>;
}
